export enum ChipType {
    FILTER = "filter",
    SUGGESTION = "suggestion",
}
